<div class="logo-container" [class]="'size-' + size">
  <img src="./assets/images/logo.svg" [alt]="alt ?? ('app-logo' | translate)" />
</div>
